module.exports = __webpack_public_path__ + "static/media/About_Philo.8954b218.md";